import { render, staticRenderFns } from "./LiveVideoPlayer.vue?vue&type=template&id=d8a80498&scoped=true"
import script from "./LiveVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveVideoPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LiveVideoPlayer.vue?vue&type=style&index=0&id=d8a80498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a80498",
  null
  
)

export default component.exports